/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;

      $( 'select' ).on( 'change', function() {
        filterPhotos();
      } );

      $( document ).on( 'click', '.photo-gallery__pagination button', function() {
        const newPageNum = $( this ).attr( 'data-value' );
        filterPhotos( newPageNum );
      } );

      function filterPhotos( page = 1 ) {
        const formData = new FormData( $( '.gallery-filters' )[0] );
        let urlQuery = new URLSearchParams( formData ).toString();
        urlQuery += '&gallery-page=' + ( page ? page : $( '.photo-gallery__pagination span' ).text() );
        console.log( urlQuery );

        history.replaceState( '', '', '?'+decodeURIComponent( urlQuery ) );

        const data = {
          'building': $( 'select[name="building-photos"]' ).val(),
          'event_type': $( 'select[name="event-type"]' ).val(),
          'page': page ? page : $( '.photo-gallery__pagination span' ).text(),
        };

        $.ajax( {
          type: 'GET',
          url: siteInfo.wpApiSettings.ll + 'cpt/filter', // note that cpt/filter is the path set in our new route in routes.php
          data: data,
          beforeSend: function( xhr ) {
            xhr.setRequestHeader( 'X-WP-Nonce', siteInfo.wpApiSettings.nonce );
            xhr.setRequestHeader( 'X-Requested-With', 'XMLHttpRequest' );
            doingAjax = true;
          },
          success: function( data ) {
            // console.log( data );
            $( '.photo-gallery-wrapper' ).html( data );

            $( '.photo-gallery' ).each( function( key, component ) {
              $( component ).find( '.photo-gallery__gallery' ).magnificPopup( {
                delegate: 'a',
                type: 'image',
                tLoading: 'Loading image #%curr%...',
                mainClass: 'mfp-img-mobile',
                gallery: {
                  enabled: true,
                  navigateByImgClick: true,
                  preload: [0, 1], // Will preload 0 - before current, and 1 after the current image
                },
                image: {
                  tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
                  titleSrc: function( item ) {
                    return item.el.attr( 'title' );
                  },
                },
              } );
            } );
          },
          complete: function( jqXHR, status ) {
            doingAjax = false;
          },
        } );
      }
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'photo-gallery-page', COMPONENT );
} )( app );
